export default __webpack_public_path__ + "static/media/round-arrow.53217cd7.svg";